import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const Close16Icon = ({vectorSize = 8, ...props}) => {
    const vectorInset = (16 - vectorSize) / 2
    const vectorEnd = 16 - vectorInset

    return (
        <Icon viewBox="0 0 16 16" fill="none" width="16px" height="16px" flexShrink={0} {...props}>
            <path
                d={`M${vectorEnd} ${vectorInset}L${vectorInset} ${vectorEnd}`}
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d={`M${vectorInset} ${vectorInset}L${vectorEnd} ${vectorEnd}`}
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

Close16Icon.propTypes = {
    vectorSize: PropTypes.number,
}

export default Close16Icon
